import FormEntriesPage from '@/views/forms/FormEntriesPage'
import FormLayout from '@/views/layouts/FormLayout'

export default function Page() {
  return (
    <FormLayout>
      <FormEntriesPage />
    </FormLayout>
  )
}
